<template>
  <div class="flex flex-col items-center">
    <span class="mt-20 flex h-10 w-10">
      <span class="absolute inline-flex h-10 w-10 animate-ping rounded-full bg-secondary-800 opacity-75"></span>
      <span class="relative inline-flex h-10 w-10 rounded-full bg-secondary-800"></span>
    </span>
  </div>
</template>
